import VueTinyTabs from './VueTinyTabs.vue';
export default VueTinyTabs;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-tiny-tabs/src/plugin.js
// module id = TZfm
// module chunks = 0